// extracted by mini-css-extract-plugin
export default {"customTooltip":"AlertsPerDayChart_customTooltip__VAs-J","graph":"AlertsPerDayChart_graph__G8SC3"};